#### Mutation conflicts

We’ve introduced a new result format for mutations that create objects.
This enables explicit handling of [mutation conflicts].

💥 The new format can be seen in the [`createWebhookSubscription`] and [`uploadCandidate`] mutations.
If your software creates webhook subscriptions,
update the selection set to account for this change:

```diff label="GraphQL"
mutation($input: CreateWebhookSubscriptionInput!) {
  createWebhookSubscription(input: $input) {
-     webhookSubscription {
-       id {
-         value
-       }
-     }
+     __typename
+     ... on CreateWebhookSubscriptionPayload_Success {
+       webhookSubscription {
+         id {
+           value
+         }
+       }
+     }
+     ... on CreateWebhookSubscriptionPayload_Conflict {
+       conflictingWebhookSubscription {
+         id {
+           value
+         }
+       }
    }
  }
}
```

Then, update your code to check for conflicts in one of two new ways:

```diff label="JavaScript"
if (
-   // Old: make assumptions based on semi-structured errors array
-   response.errors?.some(
-     (err) =>
-       err.extensions.code === 'BAD_USER_INPUT' &&
-       err.message === 'Subscription already exists',
-   )
+   // Option 1: test for existence of conflict field
+   response.data?.conflictingWebhookSubscription
+   // Option 2: test name of the response type
+   response.data?.__typename === 'CreateWebhookSubscriptionPayload_Conflict'
) {
  // Handle conflict here
}
```

[`createwebhooksubscription`]: /schema/mutation/createWebhookSubscription
[`uploadcandidate`]: /schema/mutation/uploadCandidate
[mutation conflicts]: /graphql/seek-api-conventions#mutation-conflicts
